import { Contact } from '../../../models';
export function contactDtoToContact(contactDto) {
  var primaryAddress = contactDto.emailAddresses.find(function (e) {
    return e.isPrimary;
  });
  var emailAddress = primaryAddress ? primaryAddress.emailAddress : undefined;
  var isIndividual = /^[A-Z][A-Z]INDIVIDUAL$|^INDIVIDUAL$/.test(contactDto.entityType.id);
  return new Contact(contactDto.id, contactDto.displayAs, contactDto.isClientCenterEnabled, isIndividual, contactDto.givenName, contactDto.familyName, emailAddress, undefined, contactDto.nickname, contactDto.entityType, contactDto.addresses, contactDto.nationalIdentitiesExpanded, contactDto.dateOfBirth);
}
